import { initializeApp } from 'firebase/app';
import {
    doc,
    getFirestore,
    collection,
    getDocs,
    query,
    where,
    orderBy,
    // limit,
    addDoc,
    updateDoc
} from 'firebase/firestore/lite';
import { GAME_STATUSES } from '../game/constants';
import { ee } from '../eventEmitter';

require('firebase/firestore');

const firestoreConfig = {
    apiKey: 'AIzaSyBT1bFxf2l4yLUQfH7VuxY97HbFUBiNRLQ',
    authDomain: 'tiger-new-year-2022-game.firebaseapp.com',
    projectId: 'tiger-new-year-2022-game',
    storageBucket: 'tiger-new-year-2022-game.appspot.com',
    messagingSenderId: '147449174564',
    appId: '1:147449174564:web:fded24069415ad5014d6b1'
};
const app = initializeApp(firestoreConfig);

export class Rating {
    #ratingData = null;
    #ratingPage = document.getElementById('ratingPage');
    #ratingTable = document.getElementById('ratingTable');
    #db;
    // #limit = 10;
    #notAuthUserResult = -1;
    #authInstanse;
    #currentDocumentId = null;
    #currentUserResult = {};

    constructor(auth) {
        this.#db = getFirestore(app);
        this.initEvents();
        this.#authInstanse = auth;
    }

    initEvents() {
        const toggleRatingBack = document.getElementById('toggleRatingBack');
        const toggleRatingIcons = document.getElementsByClassName('rating-icon');

        Array.from(toggleRatingIcons).forEach((toggleRatingIcon) => {
            toggleRatingIcon?.addEventListener('click', async () => {
                this.toggleRatingPage();
                await this.getRating();
                this.toggleHeightMainLayout();
                this.showRatingInfo();
                this.scrollToCurrentUser();
            });
        });

        toggleRatingBack?.addEventListener('click', () => {
            this.toggleHeightMainLayout();
            this.toggleRatingPage();
        });

        ee.on(GAME_STATUSES.END, this.setCurrentUserResult.bind(this));

        ee.on('login', () => {
            this.setCurrentUserResult(this.#notAuthUserResult);
        });
    }

    toggleRatingPage() {
        ee.emit('toggleInsidePage');
        this.#ratingPage.classList.toggle('rating-page_active');
    }

    toggleHeightMainLayout() {
        const mainLayout = document.getElementById('mainLayout');

        mainLayout.classList.toggle('main-layout_no-height-limit');

        this.calcRatingPageHeight();
    }

    calcRatingPageHeight() {
        const cssParams = `--rating-users-count: ${this.#ratingData?.length || 0}`;

        document.documentElement.style.cssText += cssParams;
    }

    async getRating() {
        const q = query(collection(this.#db, 'results'), orderBy('result'));
        let resultsSnapshot = null;
        let resultsList = null;

        try {
            resultsSnapshot = await getDocs(q);
            resultsList = resultsSnapshot?.docs;

            if (!(resultsList instanceof Array)) throw new Error('results not an array');

            this.#ratingData = resultsList.map((document) => document.data());
        } catch (err) {
            console.log(err);
        }

        return this.#ratingData;
    }

    showRatingInfo() {
        [this.parentElement] = this.#ratingTable.getElementsByTagName('tbody');
        const baseClass = 'rating-position';
        const accentClass = `${baseClass}_accent`;

        this.parentElement.innerHTML = '';

        for (let i = this.#ratingData.length - 1; i >= 0; i -= 1) {
            const result = this.#ratingData[i];
            const index = this.#ratingData.length - i - 1;

            const tr = document.createElement('tr');
            const numContainer = document.createElement('td');
            const num = document.createElement('div');
            const username = document.createElement('td');
            const score = document.createElement('td');

            tr.id = `resultItem-${result.userId}`;
            tr.classList.add(baseClass);
            numContainer.classList.add(`${baseClass}__item`);
            num.classList.add(`${baseClass}__num`);
            username.classList.add(`${baseClass}__item`);
            score.classList.add(`${baseClass}__item`);

            num.innerHTML = index + 1;
            username.innerHTML = result.username;
            score.innerHTML = result.result;

            numContainer.appendChild(num);
            tr.appendChild(numContainer);
            tr.appendChild(username);
            tr.appendChild(score);

            if (result.userId === this.#authInstanse.user.id) {
                tr.classList.add(accentClass);
                numContainer.classList.add(`${accentClass}__num-container`);
                num.classList.add(`${accentClass}__num`);
            }

            this.parentElement.appendChild(tr);
        }
    }

    // eslint-disable-next-line
    async scrollToCurrentUser() {
        if (!this.#authInstanse.user.id) return;

        // чтобы лишний раз не запрашивать пользователя (не проверять есть ли он в рейтинге)
        // мы просто проверяем есть ли у нас id, если нет, то уходим в сatch
        try {
            const currentUserTr = document.getElementById(`resultItem-${this.#authInstanse.user.id.toString()}`);

            currentUserTr.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        } catch (err) {
            console.log(err);
        }
    }

    async getUserResult(userId) {
        this.#currentUserResult = null;

        try {
            if (!userId) throw new Error('userId undefined');

            const q = query(collection(this.#db, 'results'), where('userId', '==', userId.toString()));
            const querySnapshot = await getDocs(q);

            const queryList = querySnapshot?.docs;

            if ((queryList.length)) {
                this.#currentUserResult = queryList[0].data();
                this.#currentDocumentId = queryList[0].id;
            } else this.#currentUserResult = {};
        } catch (err) {
            console.log(err);
        }

        return this.#currentUserResult;
    }

    async setNewUser(result) {
        await addDoc(collection(this.#db, 'results'), {
            result,
            userId: this.#authInstanse.user.id,
            username: this.#authInstanse.user.username
        });
    }

    async updateUserResult(result) {
        if (!this.#currentDocumentId) return;

        try {
            const querySnapshot = await doc(this.#db, 'results', this.#currentDocumentId);

            if (!querySnapshot) throw new Error('user result not found');

            await updateDoc(querySnapshot, {
                result
            });
        } catch (err) {
            console.log(err);
        }
    }

    async setCurrentUserResult(result) {
        if (!this.#authInstanse.user.id) {
            this.#notAuthUserResult = result;

            return;
        }
        const savedUserResult = await this.getUserResult(this.#authInstanse.user.id);

        if (!(savedUserResult instanceof Object)) return;

        if (!savedUserResult.userId) {
            this.setNewUser(result);
        } else if (result > savedUserResult.result) {
            this.updateUserResult(result);
        }
    }

    async saveResult(result) {
        this.#notAuthUserResult = result;
    }
}
